module.exports = __webpack_public_path__ + "media/standardized_tests/masthead-0b435b95.jpg";